import { UserDetailDto } from '../api/userManagementApi';

/**
 * Gets a display name for a user. If the user has a profile with given/family names,
 * returns the full name. Otherwise, falls back to the email address.
 *
 * This is useful for invited users who don't have a profile yet (profile is null).
 *
 * @param user - The user detail object
 * @returns A display name string
 */
export const getUserDisplayName = (
  user: UserDetailDto | null | undefined
): string => {
  if (!user) return 'Unknown User';
  if (user.profile?.givenName || user.profile?.familyName) {
    return (
      `${user.profile.givenName ?? ''} ${user.profile.familyName ?? ''}`.trim() ||
      user.email ||
      'Unknown User'
    );
  }
  return user.email || 'Unknown User';
};
